import React from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import './style.css';

export default function CancelPolicy() {
  return (
    <div className="cancel_policy_bg">
      <SEO {...pageSEO.cancelPolicy} />
      <div className="cancel_policy_banner"></div>
      <div className="cancel_policy_content">
        <section className="cancel_policy_delevery">
          <h1>Cancellation Policy</h1>
          <p>
            At <strong>Importerr.com</strong>, a brand of <strong>Boundless Trends Pvt. Ltd.</strong>, we are committed to delivering bulk orders across India in a safe and timely manner. This Cancellation Policy explains how we process cancellation, cancellation timeline and Refunds in case of cancellation of orders.
          </p>
        </section>
        <section>
          <h2>1. Order Cancellation Window</h2>
          <ul>
            <li>Customers can cancel their order directly from their account panel within 1 hour of placing the order.</li>
          </ul>
        </section>
        <section>
          <h2>2. Post-Processing Orders</h2>
          <ul>
            <li>After 1 hour, orders are automatically processed and forwarded to our suppliers for fulfillment. Once the order enters the processing stage, cancellation requests will not be accepted.</li>
          </ul>
        </section>
        <section>
          <h2>3. International Sourcing Orders</h2>
          <ul>
            <li>As many of our products are sourced from international suppliers, orders are processed immediately after confirmation. Therefore, cancellation beyond the allowed time window is not feasible.</li>
          </ul>
        </section>
        <section>
          <h2>4. Exceptions</h2>
          <ul>
            <li>Cancellation requests after the allowed time window may only be considered in exceptional cases at our sole discretion, provided the order has not yet been processed or shipped.</li>
          </ul>
        </section>
        <section>
          <h2>5. Refund on Cancellation</h2>
          <ul>
            <li>If an order is successfully cancelled within the allowed time window, the refund will be initiated to the original payment method within 7–10 business days or may be credited to the Importerr wallet, as per customer preference.</li>
          </ul>
        </section>
        <section>
          <h2>6. Customer Responsibilities</h2>
          <ul>
            <li>Customers must provide accurate details such as business name, GST number, billing/shipping address, and contact information.</li>
            <li>The buyer is responsible for ensuring that the products purchased comply with any applicable laws, licenses, or regulations in their region.</li>
          </ul>
        </section>
        <section>
          <h2>7. Contact Us</h2>
          <p>
            For cancellation-related queries or to raise a claim, please <a href="mailto:contact@importerr.com" style={{ color: 'blue', textDecoration: 'underline' }}>contact@importerr.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
